import React, { useEffect, useState } from "react";
import { Photo } from "./Photo";

const HOLD_MS = 7000;

/** Slow cinematic crossfade between 2–3 curated hero photos. Reduced motion → first photo only. */
export function HeroSpotlight({ photos }) {
  const names = Array.isArray(photos) ? photos : [photos];
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (names.length < 2 || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const id = setInterval(() => { if (document.visibilityState === "visible") setActive((i) => (i + 1) % names.length); }, HOLD_MS);
    return () => clearInterval(id);
  }, [names.length]);

  return (
    <div className="absolute inset-0" data-testid="hero-spotlight" data-active={active}>
      {names.map((name, i) => (
        <div key={name} className={`spot-layer ${i === active ? "is-active" : ""}`} data-testid={`hero-spotlight-layer-${i}`} aria-hidden={i !== active}>
          <Photo name={name} fill priority={i === 0} treat="hero" parallax={8} sizes="100vw" />
        </div>
      ))}
    </div>
  );
}
